"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.injectReducer = exports.REDUCER = void 0;

var _merge = _interopRequireDefault(require("lodash/merge"));

var _redux = require("redux");

var REDUCER = Symbol('REDUCER');
exports.REDUCER = REDUCER;

var injectReducer = function injectReducer(store, reducer) {
  if (!store[REDUCER]) {
    store[REDUCER] = {};
  }

  store[REDUCER] = (0, _merge.default)(store[REDUCER], reducer);
  store.replaceReducer((0, _redux.combineReducers)(store[REDUCER]));
};

exports.injectReducer = injectReducer;